<template>
	<div class="choice-message choice-message-center" v-if="format === 'sendMessage'">
		<p class="send-chat-message">{{$t('game.sendMessage')}}</p>
		<vue-markdown class="chat-message">{{ message }}</vue-markdown>
	</div>
	<vue-markdown class="choice-message" v-else>{{ message }}</vue-markdown>
</template>

<script>
	import VueMarkdown from 'vue-markdown';

	export default {
		name: 'choice-message',
		props: {
			format: {
				type: String,
				required: true
			},
			message: {
				type: String,
				required: true
			}
		},
		components: {
			VueMarkdown
		}
	}
</script>

<style lang="less">
	@import "~@less/font-sizes.less";

	.choice-message {
		p {
			text-align: left;
			font-weight: 700;
			margin-bottom: 0px;
		}

		&.choice-message-center {
			margin: 0 auto 0 auto;
		}

		.send-chat-message {
			margin-bottom: 5px;
			font-size: @app-font-size-send-chat-message;
		}

		.chat-message {
			background: #0084ff;
			color: white;
			padding: 10px;
			border-radius: 10px;
			font-size: @app-font-size-chat-message;
			text-align: center;
			margin: 0;
		}
	}
</style>